import script from "./AboutUs.vue?vue&type=script&lang=ts&setup=true"
export * from "./AboutUs.vue?vue&type=script&lang=ts&setup=true"

import "./AboutUs.vue?vue&type=style&index=0&id=70db0272&lang=scss"

const __exports__ = script;

export default __exports__